<!-- El subtítulo solo lo fijan las vistas de detalle/ficha: mientras exista,
     ocultamos las tabs de sección para no mezclar navegación con el detalle. -->
<ng-container *ngIf="{ subtitle: panelTitleService.subtitle$ | async } as vm">
<div class="d-flex submenu-panel">
    <h1 class="m-0 title-submenu">
      {{ submenuActive?.name }}
      <ng-container *ngIf="vm.subtitle">
        <mat-divider [vertical]="true" class="title-submenu-divider"></mat-divider>{{ vm.subtitle }}
      </ng-container>
    </h1>

    <ng-container *ngIf="!vm.subtitle && submenuActive?.items?.length > 1">
    <div
        class="list-submenu"
        *ngFor="let item of submenuActive?.items"
        [class.disabled]="
      (item.requiredSpace && !spaceSelected) ||
      item.disabled ||
      (!superadmin &&
        (
          (item.requiredSuperadmin && !superadmin) ||
          (item.requiredAdmin && !admin) ||
          (item.requiredSales && !admin && !allowSales) ||
          (item.requiredOrders && !admin && !allowOrder) ||
          (item.requiredMarketing && !admin && !allowMarketing) ||
          (item.requiredCreator && !admin && !allowCreator) ||
          (item.requiredCitylok && !allowCitylok) ||
          (item.requiredOwner && !owner)
        )
      )
    ">
        <p
            [routerLink]="['/panel-control' + item.url]"
            routerLinkActive="submenu-active"
            [routerLinkActiveOptions]="{ exact: item.exact }">
            {{ item.name }}
        </p>
    </div>
    </ng-container>
</div>
</ng-container>
